module.exports = __webpack_public_path__ + "img/3.0b02c833.png";